import type { RoomFormValues } from '@/components/form/RoomForm'
import type { RoomResponse } from '@/types/response'

export function roomToFormValues(room: RoomResponse): Partial<RoomFormValues> {
  return {
    name: room.name,
    description: room.description,
    customPrompt: room.custom_prompt,
    modelVersionId: room.model_version ? String(room.model_version.id) : '',
    agentId: room.agent ? String(room.agent.id) : '',
    departmentId: room.department ? String(room.department.id) : '',
    allowAnyUsers: room.is_allow_any_users_in_department_or_company,
    isAnswerInternalDataOnly: room.is_answer_internal_data_only,
    useCompanyFiles: room.use_company_files,
    memberIds: room.member_ids.map(String),
    roomDocuments: room.files.map((file) => ({
      id: file.id,
      name: file.name,
      mimeType: '',
      status: file.status,
    })),
    companyFileIds: room.company_files.map((file) => ({ id: file.id, folderId: file.folder_id })),
    companyFolderIds: room.company_folders.map((folder) => folder.id),
    companySourceItems: [
      ...room.company_folders.map(({ id, name }) => ({ id, name, type: 'folder' as const })),
      ...room.company_files.map(({ id, name }) => ({ id, name, type: 'file' as const })),
    ],
  }
}
